function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './message.style';
/**
 * @description If both action and onCloseClick are passed, action is prioritised. A link for that action is created if an href is passed, otherwise a button.
 */

import { jsx as ___EmotionJSX } from "@emotion/core";

var ActionButtonOrLink = function ActionButtonOrLink(_ref) {
  var action = _ref.action,
      onCloseClick = _ref.onCloseClick,
      isWholeMessageClickable = _ref.isWholeMessageClickable,
      onActionClick = _ref.onActionClick;

  if (!action) {
    return onCloseClick ? ___EmotionJSX("button", {
      type: "button",
      css: styles.messageAction(isWholeMessageClickable),
      onClick: onCloseClick,
      "data-testid": "messages__message-close"
    }, "Hide") : null;
  }

  var link = action.link,
      text = action.text,
      onClick = action.onClick;

  var handleActionClick = function handleActionClick() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    onActionClick.apply(void 0, [onClick].concat(args));
  };

  return link ? ___EmotionJSX("a", _extends({
    css: styles.messageAction(isWholeMessageClickable),
    onClick: handleActionClick,
    href: link.href
  }, link), text) : ___EmotionJSX("button", {
    css: styles.messageAction(isWholeMessageClickable),
    type: "button",
    onClick: handleActionClick
  }, text);
};

export var actionPropType = PropTypes.shape({
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  link: PropTypes.object
});
ActionButtonOrLink.propTypes = {
  action: actionPropType,
  onCloseClick: PropTypes.func,
  isWholeMessageClickable: PropTypes.bool.isRequired,
  onActionClick: PropTypes.func.isRequired
};
ActionButtonOrLink.defaultProps = {
  onCloseClick: undefined,
  action: undefined
};
export default ActionButtonOrLink;